import { inject, injectable } from 'inversify'
import type { Gridable } from '@/services/types'
import type { PaginationParams } from '@/services/tables/pagination/types'
import { SERVICE_TYPES } from '@/core/container/types'
import type { EndpointParams } from '@/services/endpoints'
import type { PaginationUrlType } from '@/services/tables/types'
import type TenDlcPhoneNumbersRepository from '@/data/repositories/domain/services/regulations/tenDlcPhoneNumbersRepository'
import TenDlcPhoneNumber from '@/data/models/domain/services/regulations/TenDlcPhoneNumber'
import type EntityManagerService from '@/data/repositories/entityManagerService'
import TmLogicError from '@/core/error/tmLogicError'

@injectable()
export default class TenDlcPhoneNumbersGridable implements Gridable<TenDlcPhoneNumber> {
  constructor(@inject(SERVICE_TYPES.EntityManager) protected readonly em: EntityManagerService) {}

  private campaignId: string | null = null

  public setCampaignId(campaignId: string) {
    this.campaignId = campaignId
  }

  public getFetchEndpointParams(): EndpointParams {
    return []
  }

  public async gridRequest(
    queryParameterBag: PaginationUrlType,
    paginationParamsBag?: PaginationParams,
    searchQuery?: string,
    searchFields?: string[],
  ) {
    if (this.campaignId === null) {
      throw new TmLogicError('campaignId is null')
    }

    return this.getRepo().gridRequest(
      {
        ...queryParameterBag,
        other: {
          campaignId: this.campaignId,
        },
      },
      paginationParamsBag,
      searchQuery,
      searchFields,
    )
  }

  protected getRepo() {
    return this.em.getRepository<TenDlcPhoneNumbersRepository>(TenDlcPhoneNumber)
  }
}
